import { render, staticRenderFns } from "./RecommenderGridRegisterWithShopifyColumn.vue?vue&type=template&id=913ffdc4&"
import script from "./RecommenderGridRegisterWithShopifyColumn.vue?vue&type=script&lang=js&"
export * from "./RecommenderGridRegisterWithShopifyColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RecommenderGridRegisterWithShopifyColumn.vue"
export default component.exports